<template>
    <v-overlay :value="loading" absolute>
      <v-row>
        <v-col class="text-center">
          <v-img v-if="isAuthenticating"
            contain
            src="@/assets/images/padlock.gif"
            max-height="50"
            transition="scale-transition"
          />
          <v-img v-else
            contain
            src="@/assets/images/loading.gif"
            max-height="50"
            transition="scale-transition"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col 
          class="text-center"
          aria-label="Loading, please wait"
          role="alert"> {{ text }} </v-col>
      </v-row>
    </v-overlay>
</template>

<script>
export default {
  // props: ['loading', 'src', 'text'],
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    isAuthenticating: {
      type: Boolean,
      required: true,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
